import FidcHistorico from './fidcHistorico';
import { useVerificaPermissao } from '../../../../shared/useVerificaPermissao';
import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../../../shared/spinner';
import { ButtonAlterar } from '../../../../shared/buttons';
import { Fidc } from '../../../../shared/model/fidc';
import FidcService from '../../../../services/fidcService';

function FidcComponent() {
  useVerificaPermissao();
  const [mensagem, setMensagem] = useState('');
  const [justificativa, setJustificativa] = useState('');
  const [fundoHistorico, setFundoHistorico] = useState<Fidc | null>(null);
  const [alterouOrdem, setAlterouOrdem] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [fidcs, setFidcs] = useState<Fidc[]>([]);

  const fidcService: FidcService = new FidcService();

  const listarTodosFidcs = async () => {
    try {
      setLoading(true);
      const responseList = await fidcService.listarTodosFidcs();
      setFidcs(responseList.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    listarTodosFidcs();
  }, []);

  const moeda = (n: number) => Number(n || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const mover = (indice: number, delta: number) => {
    const lista = [...fidcs]; const destino = indice + delta;
    if (destino < 0 || destino >= lista.length || !lista[destino].ativo || !lista[destino].elegibilidade) return;
    [lista[indice], lista[destino]] = [lista[destino], lista[indice]]; setFidcs(lista); setAlterouOrdem(true);
  };
  const salvarOrdem = async () => {
    try { await fidcService.reordenar(fidcs.filter(f => f.ativo && f.elegibilidade).map(f => f.id), justificativa); setAlterouOrdem(false); setJustificativa(''); await listarTodosFidcs(); setMensagem('Prioridades atualizadas.'); }
    catch (e: any) { setMensagem(e.response?.data || 'Não foi possível atualizar as prioridades.'); }
  };
  const exportar = () => {
    const escapar = (v: unknown) => '"' + String(v ?? '').replace(/^[=+@-]/, "'$&").replace(/"/g, '""') + '"';
    const linhas = [['Código', 'Nome do fundo', 'CNPJ', 'Limite diário', 'Utilizado', 'Saldo', 'Status', 'Prioridade'], ...fidcs.map(f => [f.id, f.nome, f.cnpj, f.limiteDiario, f.limiteDiarioUtilizado, f.saldoDisponivel, f.ativo ? 'Ativo' : 'Inativo', f.prioridade])];
    const url = URL.createObjectURL(new Blob(['\uFEFF' + linhas.map(l => l.map(escapar).join(';')).join('\r\n')], { type: 'text/csv;charset=utf-8' }));
    const a = document.createElement('a'); a.href = url; a.download = 'limites-fidc.csv'; a.click(); URL.revokeObjectURL(url);
  };
  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>BackOffice &gt; Tabelas &gt; Fundo de Investimento em Direitos Creditórios</h5>
          <Button
            onClick={() => navigate('/backoffice-tabelas/fidc/inclusao', { state: { id: 0 } })}
            id="App-button-cor-principal-escura"
          >
            + Novo FIDC
          </Button>
        </div>
        {mensagem && <div role="status" className="alert alert-info">{mensagem}</div>}
        <div className="d-flex gap-2 mb-3">
          <Button onClick={exportar}>Exportar relatório</Button>
        </div>
        
        {alterouOrdem && <div className="mb-3"><label>Justificativa da reordenação<input className="form-control" maxLength={1000} value={justificativa} onChange={e => setJustificativa(e.target.value)} /></label><Button disabled={!justificativa.trim()} onClick={salvarOrdem}>Salvar ordem</Button></div>}
        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table">Código</th>
                    <th scope="col" id="App-header-table">Nome</th>
                    <th scope="col" id="App-header-table">CNPJ</th>
                    <th scope="col" id="App-header-table">Banco</th>
                    <th scope="col" id="App-header-table">Agência</th>
                    <th scope="col" id="App-header-table">Conta</th>
                    <th scope="col" id="App-header-table">Prioridade</th>
                    <th scope="col" id="App-header-table">Status</th>
                    <th scope="col" id="App-header-table">Limite diário</th>
                    <th scope="col" id="App-header-table">Utilizado</th>
                    <th scope="col" id="App-header-table">Saldo</th>
                    <th scope="col" id="App-header-table">Histórico</th>
                    <th scope="col" id="App-header-table">Alteração</th>
                  </tr>
                </thead>
                <tbody>
                  {fidcs.map((item, indice) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nome}</td>
                      <td>{item.cnpj}</td>
                      <td>{item.banco}</td>
                      <td>{item.agencia}</td>
                      <td>{item.conta}</td>
                      <td><div className="d-flex align-items-center gap-2"><span className="badge bg-secondary">{alterouOrdem && item.ativo && item.elegibilidade ? indice + 1 : item.prioridade}</span>
                        {item.ativo && item.elegibilidade && <div className="btn-group">
                          <Button size="sm" variant="outline-primary" title="Subir prioridade" aria-label="Subir prioridade" disabled={indice === 0 || !fidcs[indice - 1]?.ativo || !fidcs[indice - 1]?.elegibilidade} onClick={() => mover(indice, -1)}>↑</Button>
                          <Button size="sm" variant="outline-primary" title="Descer prioridade" aria-label="Descer prioridade" disabled={indice === fidcs.length - 1 || !fidcs[indice + 1]?.ativo || !fidcs[indice + 1]?.elegibilidade} onClick={() => mover(indice, 1)}>↓</Button>
                        </div>}</div></td>
                      <td>{item.ativo ? 'Ativo' : 'Inativo'}</td><td>{moeda(item.limiteDiario)}</td><td>{moeda(item.limiteDiarioUtilizado)}</td><td>{moeda(item.saldoDisponivel)}</td>
                      <td><Button size="sm" onClick={() => setFundoHistorico(item)}>Consultar</Button></td>
                      <td>
                        <Link to={`/backoffice-tabelas/fidc/alteracao`} state={{ id: item.id }}>
                          <ButtonAlterar />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {fundoHistorico && <FidcHistorico id={fundoHistorico.id!} nome={fundoHistorico.nome} onHide={() => setFundoHistorico(null)} />}
      </div >
    </>
  );
}

export default FidcComponent;